import iIcon from './icon';

export default function KoFace({ fill = 'currentColor', width, height, title = undefined }: iIcon) {
  return (
    <svg width={width ?? 103} height={height ?? 80} viewBox="0 0 103 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title>{title}</title>}
      <path
        fill={fill}
        d="M22.1,15.5l7.3-7.3c1.2-1.2,1.2-3.3,0-4.5-1.2-1.2-3.3-1.2-4.5,0l-7.3,7.3-7.3-7.3c-1.2-1.2-3.3-1.2-4.5,0-1.2,1.2-1.2,3.3,0,4.5l7.3,7.3-7.3,7.3c-1.2,1.2-1.2,3.3,0,4.5.6.6,1.4.9,2.3.9s1.6-.3,2.3-.9l7.3-7.3,7.3,7.3c.6.6,1.4.9,2.3.9s1.6-.3,2.3-.9c1.2-1.2,1.2-3.3,0-4.5l-7.3-7.3Z"
      />
      <path
        fill={fill}
        d="M51.4,48c-8,0-14.5,6.5-14.5,14.5s6.5,14.5,14.5,14.5,14.5-6.5,14.5-14.5-6.5-14.5-14.5-14.5ZM51.4,71c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5,8.5,3.8,8.5,8.5-3.8,8.5-8.5,8.5Z"
      />
      <path
        fill={fill}
        d="M89.7,15.5l7.3-7.3c1.2-1.2,1.2-3.3,0-4.5-1.2-1.2-3.3-1.2-4.5,0l-7.3,7.3-7.3-7.3c-1.2-1.2-3.3-1.2-4.5,0-1.2,1.2-1.2,3.3,0,4.5l7.3,7.3-7.3,7.3c-1.2,1.2-1.2,3.3,0,4.5.6.6,1.4.9,2.3.9s1.6-.3,2.3-.9l7.3-7.3,7.3,7.3c.6.6,1.4.9,2.3.9s1.6-.3,2.3-.9c1.2-1.2,1.2-3.3,0-4.5l-7.3-7.3Z"
      />
    </svg>
  );
}
